import { isMiniApp } from './platform';
import { Link } from 'react-router-dom';
import { isInternal, pageRoute, privacyUrl } from './content';
import {
  channelPages,
  isInformationKey,
  privacyKey,
  referenceKey,
} from '@ulaw/content-types/resources';
import { university } from '@ulaw/content-types/brand';
import { useState, type ReactNode } from 'react';
function samePage(raw: string, known: string) {
  try {
    const a = new URL(raw), b = new URL(known);
    return !a.username && !a.password && a.origin === b.origin &&
      a.pathname.replace(/\/+$/, '') === b.pathname.replace(/\/+$/, '');
  } catch { return false; }
}
export function miniRoute(url: string): string | undefined {
  if (isInformationKey(url)) return pageRoute(url);
  if (samePage(url, privacyUrl()) || samePage(url, new URL('/terms', privacyUrl()).href)) return pageRoute(privacyKey);
  const channel = channelPages.find((c) => samePage(url, c.url));
  if (channel) return pageRoute(channel.key);
  if (samePage(url, university.website)) return '/admissions';
  if (isInternal(url)) return pageRoute(url);
  const key = referenceKey(url);
  return key ? pageRoute(key) : undefined;
}
export function ContentLink({
  url,
  children,
  className,
  external = false,
}: {
  url: string;
  children: ReactNode;
  className?: string;
  external?: boolean;
}) {
  const [notice, setNotice] = useState('');
  if (isMiniApp()) {
    if (url === university.zalo.url || /^(tel:|mailto:)/i.test(url)) {
      const act = async () => {
        setNotice('');
        try {
          if (url === university.zalo.url) {
            const { openChat } = await import('zmp-sdk');
            await openChat({ type: 'oa', id: university.zalo.id });
          } else if (url.startsWith('tel:')) {
            const { openPhone } = await import('zmp-sdk');
            await openPhone({ phoneNumber: url.slice(4) });
          } else {
            await navigator.clipboard.writeText(url.slice(7));
            setNotice('Đã sao chép địa chỉ email.');
          }
        } catch {
          setNotice(
            url.startsWith('mailto:')
              ? 'Bạn có thể nhấn giữ địa chỉ email để sao chép.'
              : 'Chưa thể mở liên hệ. Vui lòng thử lại hoặc gửi yêu cầu tư vấn trong ứng dụng.'
          );
        }
      };
      return (
        <>
          <button
            type="button"
            className={'native-contact ' + (className || '')}
            onClick={() => void act()}
          >
            {children}
          </button>
          {notice && <small role="status">{notice}</small>}
        </>
      );
    }
    const route = miniRoute(url);
    return route ? (
      <Link className={className} to={route}>
        {children}
      </Link>
    ) : (
      <span className={className}>{children}</span>
    );
  }
  if (!/^(https?:|tel:|mailto:)/i.test(url)) return <span className={className}>{children}</span>;
  if (!external && isInternal(url))
    return (
      <Link to={pageRoute(url)} className={className}>
        {children}
      </Link>
    );
  return (
    <a
      href={url}
      className={className}
      target={/^https?:/.test(url) ? '_blank' : undefined}
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}
